module.exports = __webpack_public_path__ + "static/media/Final-Day.57e86755.webp";